export { default } from './LandingCarCard';
